<template>
    <div class="flex text-20 font-bold gap-8" v-if="openingTimes && set">
        <WFIcon name="open" class="w-22 h-22"></WFIcon>
        <div v-if="open">
            <WFTranslate v-if="closesIn != null" k="closes_in" :params="[closesIn]"></WFTranslate>
            <WFTranslate  k="is_open" class="text-positive"></WFTranslate>
        </div>
        <div v-if="!open">
            <WFTranslate v-if="opensIn != null" k="opens_in" :params="[opensIn]"></WFTranslate>
            <WFTranslate k="is_closed" class="text-negative"></WFTranslate>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
const dayNames = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

export default {
    computed: {
		...mapState('wf', ['language']),
	},
    props: {
        openingTimes: {
            default: null,
            type: Object,
        },
    },
    data() {
        return {
            open: false,
            closesIn: "",
            opensIn: "",
            set: false
        };
    },
    watch: {
        openingTimes() {
            this.isShopOpen();
        },
    },
    mounted () {
        this.isShopOpen();
    },
    methods: {
        isShopOpen () {
            if (!this.openingTimes) return;

            const now = new Date();            
            const today = dayNames[now.getDay()];
            
            if (!this.openingTimes[today]) return;

            // Get today's opening times
            const { start, end } = this.openingTimes[today];
            if (start == null || end == null) return;

            // Convert times to minutes since midnight
            const [startHour, startMin] = start.split(":").map(Number);
            const [endHour, endMin] = end.split(":").map(Number);
            const startMinutes = startHour * 60 + startMin;
            const endMinutes = endHour * 60 + endMin;

            // Current time in minutes
            const currentMinutes = now.getHours() * 60 + now.getMinutes();
            this.closesIn = end;
            this.opensIn = start;
            this.open = currentMinutes >= startMinutes && currentMinutes <= endMinutes;
            this.set = true;
        }
    }
}
</script>